module.exports = "<select name=\"currency\" required (change)=\"currencyChanged($event.target.value)\">\n    <option *ngFor=\"let currency of currencies\" value=\"{{currency}}\" [selected]=\"selected == currency\">{{currency}}</option>\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/currency-picker/currency-picker.component.html
// module id = ./src/app/currency-picker/currency-picker.component.html
// module chunks = main